import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useFormik } from 'formik';
import { employeeSchema } from 'schema';
import { FormLabel, FormControl, Input, FormHelperText,IconButton, InputAdornment } from '@mui/material';
import { postApi } from 'views/services/api';
import PropTypes from 'prop-types';

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

import { toast } from 'react-toastify';
import { useState } from 'react';

const AddEmployee = (props) => {
  const { open, handleClose } = props;
  const [showNewPassword, setShowNewPassword] = useState(false);

  const initialValues = {
    employeeType: 'default',
    shift: 'default',
    phoneNumber: '',
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    idCardType: 'default',
    idcardNumber: '',
    address: '',
    idFile: null,
    idFile2: null,
    salary: '',
    role: 'Staff'
  };

  const AddData = async (values) => {
    console.log("values ===>",values);
    try {
      const formData = new FormData();
      formData.append('firstName', values.firstName);
      formData.append('lastName', values.lastName);

      formData.append('email',values.email);
      formData.append('password',values.password);

      formData.append('phoneNumber', values.phoneNumber);
      formData.append('shift', values.shift);
      formData.append('hotelId', values.hotelId);
      formData.append('employeeType', values.employeeType);
      formData.append('idCardType', values.idCardType);
      formData.append('idcardNumber', values.idcardNumber);
      formData.append('address', values.address);
      formData.append('salary', values.salary);
      formData.append('idFile', values.idFile);
      formData.append('idFile2', values.idFile2);
      formData.append('role', values.employeeType );

      //-------------------------------------
      let response = await postApi('api/employee/add', formData);
      if (response.status === 200) {
        toast.success('Employee Added successfully');
        handleClose();
        // resetForm();
      } else {
        toast.error('cannot add Employee');
      }
    } catch (e) {
      console.log(e);
      toast.error('cannot add Employee');
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema: employeeSchema,
    onSubmit: async (values, { resetForm }) => {
      values.hotelId = JSON.parse(localStorage.getItem('hotelData')).hotelId;
      AddData(values, resetForm);
    }
  });

  return (
    <div>
      <Dialog open={open} aria-labelledby="scroll-dialog-title" aria-describedby="scroll-dialog-description">
        <DialogTitle
          id="scroll-dialog-title"
          style={{
            display: 'flex',
            justifyContent: 'space-between'
          }}
        >
          <Typography variant="h6">Add New Employee</Typography>
          <Typography>
            <Button onClick={handleClose} style={{ color: 'red' }}>
              Cancel
            </Button>
          </Typography>
        </DialogTitle>

        <DialogContent dividers>
          <form onSubmit={formik.handleSubmit} encType="multipart/form-data">
            <Grid container rowSpacing={3} columnSpacing={{ xs: 0, sm: 5, md: 4 }}>
              <Grid item xs={12} sm={4} md={6}>
                <FormControl fullWidth>
                  <FormLabel>Employee Type</FormLabel>
                  <Select
                    id="employeeType"
                    name="employeeType"
                    label=""
                    size="small"
                    fullWidth
                    placeholder=""
                    value={formik.values.employeeType}
                    onChange={formik.handleChange}
                    error={formik.touched.employeeType && Boolean(formik.errors.employeeType)}
                  >
                    <MenuItem value="default" disabled>
                      Select Employee Type
                    </MenuItem>

                    <MenuItem value="manager">Manager</MenuItem>
                    <MenuItem value="cleaning">Cleaning</MenuItem>
                    <MenuItem value="reception">Reception</MenuItem>
                    <MenuItem value="cook">Cook</MenuItem>
                    <MenuItem value="waiter">Waiter</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={4} md={6}>
                <FormControl fullWidth>
                  <FormLabel>Working Shift</FormLabel>
                  <Select
                    id="shift"
                    name="shift"
                    label=""
                    size="small"
                    fullWidth
                    value={formik.values.shift}
                    onChange={formik.handleChange}
                    error={formik.touched.shift && Boolean(formik.errors.shift)}
                  >
                    <MenuItem value="default" disabled>
                      Select Working Shift
                    </MenuItem>

                    <MenuItem value="Day-Shift 08:00 AM - 08:00 PM">( Day-Shift ) 08:00 AM - 08:00 PM </MenuItem>
                    <MenuItem value="Night-Shift 08:00 PM - 08:00 AM">( Night-Shift ) 08:00 PM - 08:00 AM </MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormLabel>First Name</FormLabel>
                <TextField
                  id="firstName"
                  name="firstName"
                  size="small"
                  fullWidth
                  placeholder="Enter First Name"
                  value={formik.values.firstName}
                  onChange={formik.handleChange}
                  error={formik.touched.firstName && Boolean(formik.errors.firstName)}
                  helperText={formik.touched.firstName && formik.errors.firstName}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormLabel>Last Name</FormLabel>
                <TextField
                  id="lastName"
                  name="lastName"
                  size="small"
                  fullWidth
                  placeholder="Enter Last Name"
                  value={formik.values.lastName}
                  onChange={formik.handleChange}
                  error={formik.touched.lastName && Boolean(formik.errors.lastName)}
                  helperText={formik.touched.lastName && formik.errors.lastName}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormLabel>Email</FormLabel>
                <TextField
                  id="email"
                  name="email"
                  size="small"
                  fullWidth
                  placeholder="Enter Email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  error={formik.touched.email && Boolean(formik.errors.email)}
                  helperText={formik.touched.email && formik.errors.email}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormLabel>Password</FormLabel>
                <TextField
                  id="password"
                  name="password"
                  size="small"
                  // type="password"
                  type={showNewPassword ? 'text' : 'password'}
                  fullWidth
                  placeholder="Enter Password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  error={formik.touched.password && Boolean(formik.errors.password)}
                  helperText={formik.touched.password && formik.errors.password}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={() => setShowNewPassword(!showNewPassword)} edge="end">
                          {showNewPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={6}>
                <FormLabel>Id card Type</FormLabel>
                <Select
                  id="idCardType"
                  name="idCardType"
                  size="small"
                  fullWidth
                  value={formik.values.idCardType}
                  onChange={formik.handleChange}
                  error={formik.touched.idCardType && Boolean(formik.errors.idCardType)}
                >
                  <MenuItem value="default" disabled>
                    Select Id Card Type
                  </MenuItem>
                  <MenuItem value="Aadharcard">Aadhar Card</MenuItem>
                  <MenuItem value="VoterIdCard">VoterId Card</MenuItem>
                  <MenuItem value="PanCard">Pan Card</MenuItem>
                  <MenuItem value="DrivingLicense">Driving License</MenuItem>
                </Select>
                <FormHelperText error={formik.touched.idCardType && formik.errors.idCardType}>
                  {formik.touched.idCardType && formik.errors.idCardType}
                </FormHelperText>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormLabel>Id Card Number</FormLabel>
                <TextField
                  id="idcardNumber"
                  name="idcardNumber"
                  size="small"
                  type="text"
                  fullWidth
                  placeholder="Enter card number"
                  value={formik.values.idcardNumber}
                  onChange={formik.handleChange}
                  error={formik.touched.idcardNumber && Boolean(formik.errors.idcardNumber)}
                  helperText={formik.touched.idcardNumber && formik.errors.idcardNumber}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormLabel>Upload ID Card Front</FormLabel>
                <Input
                  id="idFile"
                  name="idFile"
                  type="file"
                  onChange={(event) => formik.setFieldValue('idFile', event.currentTarget.files[0])}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormLabel>Upload ID Card Back</FormLabel>
                <Input
                  id="idFile2"
                  name="idFile2"
                  type="file"
                  onChange={(event) => formik.setFieldValue('idFile2', event.currentTarget.files[0])}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormLabel>Phone Number</FormLabel>
                <TextField
                  id="phoneNumber"
                  name="phoneNumber"
                  size="small"
                  type="number"
                  fullWidth
                  placeholder="Enter Phone Number"
                  value={formik.values.phoneNumber}
                  onChange={(e) => {
                    const phoneNumber = e.target.value.replace(/\D/g, '').slice(0, 10);
                    formik.setFieldValue(`phoneNumber`, phoneNumber);
                  }}
                  error={formik.touched.phoneNumber && Boolean(formik.errors.phoneNumber)}
                  helperText={formik.touched.phoneNumber && formik.errors.phoneNumber}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormLabel>Address</FormLabel>
                <TextField
                  id="address"
                  name="address"
                  size="small"
                  fullWidth
                  placeholder="Enter Physical Address"
                  value={formik.values.address}
                  onChange={formik.handleChange}
                  error={formik.touched.address && Boolean(formik.errors.address)}
                  helperText={formik.touched.address && formik.errors.address}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormLabel>Salary</FormLabel>
                <TextField
                  id="salary"
                  name="salary"
                  size="small"
                  fullWidth
                  placeholder="Enter salary"
                  value={formik.values.salary}
                  onChange={formik.handleChange}
                  error={formik.touched.salary && Boolean(formik.errors.salary)}
                  helperText={formik.touched.salary && formik.errors.salary}
                />
              </Grid>
              {/* //-------------------------------------------------------------------- */}
            </Grid>

            <DialogActions>
              <Button type="submit" variant="contained" color="primary">
                Add Employee
              </Button>
            </DialogActions>
          </form>
        </DialogContent>
      </Dialog>
    </div>
  );
};

AddEmployee.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired
};

export default AddEmployee;
